import {
    getInstance
} from "./authWrapper";
import store from "../store/store";
import state from "../store/state";
import CommonServices from "../services/common.services.js";

export const authGuard = (to, from, next) => {
    const authService = getInstance();

    const fn = () => {
        if (to.matched.some(record => record.meta.requiresSingleAuth)) {
            if (!store.state.isSingleSignedIn || !store.state.inviteId) {
                return next({
                    name: "singlelogin"
                });
            } else {
                return next(); // Continue to intended route
            }
        }
        if (authService.isAuthenticated) {
            var requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
            var isSuperAdmin = authService.isSuperAdmin;
            store.dispatch("SetIsSuperadmin", isSuperAdmin);
            store.dispatch("SetIsDocRegAdmin", authService.isDocRegAdmin);
            if (requiresSuperAdmin && !isSuperAdmin) {
                authService.logout();
                this.$router.push({ path: "/" });
            }
            else {
                if (!state.isSignedIn) {
                    store.commit("HasSignedIn", true);
                    CommonServices.UserDetails()
                    .then((res) => {
                        store.dispatch("SetUserInfo", res.data);
                    })
                    .catch(() => {
                    });
                }
                return next();
            }
        }

        authService.loginWithRedirect({
            appState: {
                targetUrl: to.fullPath
            }
        });
    };

    if (!authService.loading) {
        return fn();
    }

    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn();
        }
    });
};